import { useState } from "react";
import { toast } from "sonner";
import { KeyRound } from "lucide-react";
import { adminApi, formatApiErrorDetail } from "@/lib/adminApi";
import { Field, inputCls, btnPrimary } from "./ui";

export default function AccountPanel({ user }) {
  const [current, setCurrent] = useState("");
  const [next, setNext] = useState("");
  const [confirm, setConfirm] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    if (next.length < 10) return toast.error("New password must be at least 10 characters.");
    if (next !== confirm) return toast.error("The two new passwords don't match.");
    setSaving(true);
    try {
      await adminApi.post("/account/password", {
        current_password: current,
        new_password: next,
      });
      setCurrent("");
      setNext("");
      setConfirm("");
      toast.success("Password changed. Use it next time you log in.");
    } catch (e) {
      toast.error(formatApiErrorDetail(e.response?.data?.detail));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div data-testid="admin-account-panel" className="max-w-2xl">
      <p className="text-sm leading-relaxed text-latte">
        This is your booth key. Change it to something only you know &mdash; it takes effect
        immediately and survives every deploy.
      </p>

      <div className="mt-8 rounded-2xl border border-gold/30 bg-cocoa p-6 md:p-10">
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-latte">
          Signed in as
        </p>
        <p data-testid="admin-account-email" className="mt-2 font-editorial text-2xl italic text-gold">
          {user?.email}
        </p>

        <div className="mt-8 space-y-5">
          <Field label="Current password">
            <input
              data-testid="account-current-password"
              type="password"
              autoComplete="current-password"
              className={inputCls}
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
            />
          </Field>
          <Field label="New password (10+ characters)">
            <input
              data-testid="account-new-password"
              type="password"
              autoComplete="new-password"
              className={inputCls}
              value={next}
              onChange={(e) => setNext(e.target.value)}
            />
          </Field>
          <Field label="Confirm new password">
            <input
              data-testid="account-confirm-password"
              type="password"
              autoComplete="new-password"
              className={inputCls}
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
            />
          </Field>
        </div>

        <button
          data-testid="account-save-password-button"
          onClick={save}
          disabled={saving || !current || !next}
          className={`${btnPrimary} mt-8`}
        >
          <span className="inline-flex items-center gap-2">
            <KeyRound size={15} /> {saving ? "Changing the locks…" : "Change password"}
          </span>
        </button>
      </div>
    </div>
  );
}
